import { getToken } from "../cookie/authCookie";
import axiosInstance from "./config/axiosConfigs";

export const PlaftFormAPI = {

  getAllPlatformProducts: async function () {
    const response = await axiosInstance.request({
      url: `/platform/products`,
      method: "GET",
      withCredentials: true,
      // timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getAllPlatformClubReservationPlans: async function () {
    const response = await axiosInstance.request({
      url: `/platform/products/reservation/plans`,
      method: "GET",
      withCredentials: true,
      // timeout: 10000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
};